import { motion } from "framer-motion";
import React, { useEffect } from "react";
import styled from "styled-components";
import * as Variables from "../globalStyles/Variables";

const PopUpContainer = styled(motion.div)`
    z-index: 1000;
    bottom: 0;
    position: fixed;
    height: 100%;
    display: flex;
    background: #00000061;
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: flex-end;
    justify-content: center;

    @media ${Variables.device.tablet}{
        align-items: center;
    }
`;

const PopUpChild = styled(motion.div)`
width: 100%;
    bottom: 0;
    overflow: auto;
    box-shadow: 0px 0px 56px #000000;
    border-radius: 16px;  
    max-height: 100%;

    @media ${Variables.device.tablet}{
        width: 100%;
        max-width: 500px;
        margin: 0 auto;
        align-self: center;    }

`;

const pageVariants = {
    initial: {
        y: "100%",
        opacity: 0,
        scale: 0.9
    },
    in: {
        y: 0,
        opacity: 1,
        scale: 1

    },
    out: {
        y: "100%",
        opacity: 0,
        scale: 0.9
    }
};

const PopUp = ({ children }: { children: JSX.Element }) => {

    useEffect(() => {
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);


    return (
        <PopUpContainer
        >
            <PopUpChild initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={{ type: "spring", bounce: 0.1, duration: 0.3 }}
                    >
                {children}
            </PopUpChild>
        </PopUpContainer>
    );
};

export default PopUp;
